import React, { useState, useEffect } from 'react';
import cx from 'classnames';
import styles from '../Writes.module.scss';
import { ArrowLeft, Users, PlusCircle } from 'react-feather';
import studentGenericAvatar from '../../../images/loader-boomer.png';
import { Search } from 'react-feather';
import { useNavigate } from '@reach/router';
import { useMutation } from '@apollo/react-hooks';
import * as Icon from 'react-feather';
import { DELETE_STUDENTS_FROM_GROUP, GET_GROUPS } from '../services/graphql';

const ManageGroupStudents = ({ selectedGroup, navigateBack, schoolId }) => {
    const navigate = useNavigate();

    // Internal props
    const [selectedStudents, setSelectedStudents] = useState([]);
    const [searchTherm, setSearchTherm] = useState('');
    const [visibleGroupStudents, setVisibleGroupStudents] = useState([]);

    // Functions
    const onSelectStudent = (e) => {
        if (selectedStudents.indexOf(e.target.value) !== -1) {
            setSelectedStudents(
                selectedStudents.filter((s) => s !== e.target.value)
            );
        } else {
            setSelectedStudents([...selectedStudents, e.target.value]);
        }
    };

      const [deleteStudentsFromGroup, { loading: deleteProcessOngoing }] = useMutation(
        DELETE_STUDENTS_FROM_GROUP,
        {
            variables: {
                groupId: selectedGroup?.id,
                studentIds: selectedStudents,
            },
            onError: () => {
                setSelectedStudents([]);
                alert(
                    `The ${
                        selectedStudents.length > 1 ? 'Students' : 'Student'
                    } could not be removed from the group. Please try again.`
                );
            },
            onCompleted: () => {
                setSelectedStudents([]);
                alert(
                    `${
                        selectedStudents.length > 1 ? 'Students were' : 'Student was'
                    } successfully removed from the group.`
                );
            },
            refetchQueries: [
                {
                    query: GET_GROUPS,
                    variables: {
                        schoolId: schoolId,
                    },
                },
            ],
            awaitRefetchQueries: true,
        }
    );

    const checkForStudentsGroupLength = () => {
        const remainingStudentsCount = selectedGroup.students.length - selectedStudents.length;
        return remainingStudentsCount < 5;
    };

    // Effects
    useEffect(() => {
        if (selectedGroup) {
            const result =
                searchTherm === ''
                    ? selectedGroup.students
                    : selectedGroup.students.filter((student) =>
                          student?.displayName
                              ?.toLowerCase()
                              .includes(searchTherm)
                      );
            setVisibleGroupStudents(result);
        }
    }, [searchTherm, selectedGroup]);

    if (
        selectedGroup &&
        selectedGroup.students &&
        selectedGroup.students.length
    ) {
        return (
            <>
                <div className='page-header'>
                    <div className='page-header__content'>
                        <div className='page-header__content__inner'>
                            <h2 className='page-header__content__title'>
                                <Users />Manage Group
                            </h2>
                        </div>
                    </div>
                    <div className='page-header__actions'>
                        <button
                            className='u-display-flex u-align-center u-text-dark'
                            onClick={navigateBack}
                        >
                            <ArrowLeft className='u-m-right-1' /> Back
                        </button>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-4'>
                        <input
                            className={`${styles.utilitiesBtn} basic-form__text-box u-align-center`}
                            type='search'
                            placeholder='Search'
                            onChange={(e) => setSearchTherm(e.target.value)}
                            value={searchTherm}
                        />
                        <Search
                            size={20}
                            className={styles.utilitiesSearchIcon}
                        />
                    </div>

                    <div className={`${styles.manageGroupsActions} col-md-4`}>
                         <button
                            className={cx(
                                styles.classActionsLink,
                                styles.classActionsLinkIcon,
                                !selectedStudents.length || deleteProcessOngoing || checkForStudentsGroupLength()
                                    ? styles.classActionsLinkDisabled
                                    : ''
                            )}
                            onClick={() => deleteStudentsFromGroup()}
                        >
                            <Icon.Trash />
                            Delete Student
                        </button>
                    </div>

                </div>

                <div className='row'>
                    <div
                        className={cx(
                            'col-lg-4 col-md-6',
                            styles.boomerCardContainer
                        )}
                        onClick={() => {
                            navigate(`/startWrite/addStudentsToGroup/${selectedGroup.id}`)
                        }}
                    >
                        <div className={cx(styles.addTaskBtnContent, 'card card-hover')}>
                            <PlusCircle className={styles.addTaskBtnIcon} />
                        </div>
                    </div>
                    {visibleGroupStudents.map((student, index) => {
                        return (
                            <div
                                key={index}
                                className={cx(
                                    'col-lg-4 col-md-6',
                                    styles.boomerCardContainer
                                )}
                            >
                                <div className='card card-hover'>
                                    <div
                                        className={
                                            styles.boomerCardContainerContent
                                        }
                                    >
                                        <div
                                            className={cx(
                                                'basic-form__group--check',
                                                styles.stCheck,
                                                styles.stCheckTop
                                            )}
                                        >
                                            <input
                                                name='student'
                                                className='basic-form__check-box'
                                                type='checkbox'
                                                value={student.id}
                                                onChange={(e) =>
                                                    onSelectStudent(e)
                                                }
                                                checked={
                                                    selectedStudents.indexOf(
                                                        student.id
                                                    ) > -1
                                                }
                                                id={`st_${student.id}`}
                                            />
                                            <label
                                                className='basic-form__check-label'
                                                htmlFor={`st_${student.id}`}
                                            >
                                                &nbsp;
                                            </label>
                                        </div>

                                        <div
                                            className={
                                                styles.boomerCardContainerAvatar
                                            }
                                        >
                                            <img
                                                src={
                                                    student.boomerAvatarUrl
                                                        ? student.boomerAvatarUrl
                                                        : studentGenericAvatar
                                                }
                                                alt='Student Avatar'
                                            ></img>
                                        </div>
                                        <div
                                            className={
                                                styles.boomerCardContainerName
                                            }
                                        >
                                            {student.displayName}
                                        </div>

                                        <div
                                            className={
                                                styles.boomerCardContainerWritingProject
                                            }
                                        >
                                            {student.classes && student.classes.length ? student.classes[0].name : ''}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </>
        );
    }

    return <></>;
};

export default ManageGroupStudents;
